<template>
  <div class="page">
    <div class="card-list">
      <div class="card-item">
        <div class="card-item-count">{{ totalDistributePrice }}</div>
        <div class="card-item-text">总佣金</div>
      </div>
      <div class="card-item">
        <div class="card-item-count">{{ currentDistributePrice }}</div>
        <div class="card-item-text">本月佣金</div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/api";

export default {
  name: "Home",
  data: function () {
    return {
      totalDistributePrice: "0.00元",
      currentDistributePrice: "0.00元"
    }
  },
  mounted: function () {

  },
  methods: {}
}
</script>

<style scoped>
.page {
  padding: 20px;
  border: 1px solid #EEEEEE;
  border-radius: 10px;
  box-shadow: #EEEEEE 0 0 10px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.card-list {
  display: flex;
}

.card-item {
  width: 240px;
  height: 100px;
  margin-top: 10px;
  margin-left: 10px;
  border-radius: 10px;
  background-color: #07C160;
}

.card-item-count {
  width: 240px;
  height: 60px;
  font-size: 24px;
  line-height: 60px;
  text-align: center;
  color: #FFFFFF;
}

.card-item-text {
  width: 240px;
  height: 40px;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #FFFFFF;
}
</style>
